import React, { useState } from "react";
import { Card, Offcanvas, Button, ListGroup } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Menu as MenuIcon, ChevronRight } from "lucide-react";

const SideMenu = (props) => {
  const [show, setShow] = useState(false);
  const location = useLocation(); // Hook to identify the current page

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const MenuContent = () => (
    <ListGroup variant='flush' className="py-2">
      {props.menuu.map((mem, index) => {
        const isActive = location.pathname === mem.link;
        return (
          <ListGroup.Item key={index} className='border-0 px-2 py-1'>
            <Link
              to={mem.link}
              className={`text-decoration-none d-flex align-items-center justify-content-between rounded-3 py-2 px-3 transition-all ${
                isActive 
                ? 'bg-primary text-white shadow-sm fw-bold' 
                : 'text-dark hover-bg-light'
              }`}
              onClick={handleClose}
              style={{ 
                fontSize: '14px',
                transition: "all 0.2s ease-in-out" 
              }}
            >
              <span className="d-flex align-items-center">
                {mem.name}
              </span>
              {isActive && <ChevronRight size={14} className="opacity-75" />}
            </Link>
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );

  return (
    <>
      {/* MOBILE VIEW */}
      <div className='d-md-none mb-3 px-2'>
        <Button
          variant='white'
          onClick={handleShow}
          className='w-100 d-flex align-items-center justify-content-between shadow-sm py-2 px-3 border rounded-pill bg-white'
        >
          <div className="d-flex align-items-center">
            <MenuIcon size={18} className='me-2 text-primary' />
            <span className="fw-bold small text-secondary">{props.Menu}</span>
          </div>
          <ChevronRight size={16} className="text-muted" />
        </Button>

        <Offcanvas show={show} onHide={handleClose} placement='start' className="rounded-end-4">
          <Offcanvas.Header closeButton className='bg-primary text-white shadow-sm'>
            <Offcanvas.Title className='fw-bold fs-5'>{props.Menu}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className='p-0 bg-light'>
            <MenuContent />
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      {/* DESKTOP VIEW */}
      <Card className='mb-4 d-none d-md-block shadow-sm border-0 rounded-4 overflow-hidden'>
        <Card.Header className='bg-primary text-white fw-bold py-3 border-0 letter-spacing-1 text-center small text-uppercase'>
          {props.Menu}
        </Card.Header>
        <Card.Body className='p-1 bg-white'>
          <MenuContent />
        </Card.Body>
      </Card>
    </>
  );
};

export default SideMenu;